<template>
    <div>
        <div class="mag" v-if="$route.name != 'article' && folderCategories">
            <mag-cover :cover="dico.cover" :subtitle="dico.subtitle" :title="dico.title" />
            <mag-teasers
                v-if="folderCategories.length"
                :categories="folderCategories"
                @articlesLoaded="scrollToCategory($route.query.category)"
            />
        </div>
        <router-view></router-view>
        <scroll-top />
    </div>
</template>

<script>
import MagCover from "./MagCover.vue";
import MagTeasers from "./teaser/MagTeasers.vue";
import { Services } from "src/services/Services";
import scrollManager from "src/components/convention/managers/scrollManager";
import ScrollTop from "src/components/common/scrollTop/ScrollTop.vue";

export default {
    components: {
        MagCover,
        MagTeasers,
        ScrollTop,
    },
    data() {
        return {
            folderCategories: [],
        };
    },
    computed: {
        dico() {
            return this.$privateDico.mag;
        },
    },
    async created() {
        this.folderCategories = await Services.api.mag.getCategories();
    },
    mounted() {
        this.scrollToCategory(this.$route.query.category);
    },
    watch: {
        folderCategories() {
            this.scrollToCategory(this.$route.query.category);
        },
        $route(to) {
            this.scrollToCategory(to.query.category);
        },
    },
    methods: {
        scrollToCategory(categoryName) {
            if (categoryName) {
                setTimeout(() => {
                    scrollManager.scrollToId(categoryName, 100);
                }, 500);
            }
        },
    },
};
</script>

<style lang="sass" scoped></style>
